// extracted by mini-css-extract-plugin
export default {"root":"MobilePaginationWithJump_root__EXYFS","navButton":"MobilePaginationWithJump_navButton__meNlM","pageInfo":"MobilePaginationWithJump_pageInfo__c1DM0"};